import { styled as muiStyled } from '@mui/material'

export const CoolMultiCardCarouselHeaderContainer = muiStyled('div')(
  ({ theme }) => `
    display: flex;
    flex-direction: column;
    text-align: center;
    align-items: center;
    font-size: 46px;
    .heading {
        font-size:0.7em;
        font-weight: 600;
        color: #fff;
    }
    .sub-heading {
        font-size:0.65em;
        color: #fff;
    }
    @media(min-width: 768px){
        font-size: 46px;
        .heading {
            font-size:1em;
        }
        .sub-heading {
            font-size:0.8em;
        }
    }
`,
)
